module.exports = __webpack_public_path__ + "img/notes.743014e5.svg";